var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMenuWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "21px",
    viewBox: "0 0 6 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icMenuWhite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customised-Themes",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger---dark-green",
    transform: "translate(-353.000000, -79.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icMenuWhite",
    transform: "translate(353.500000, 15.333333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(2.500000, 10.000000) scale(-1, -1) rotate(90.000000) translate(-2.500000, -10.000000) translate(-7.500000, 7.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,2.5 C5,3.88025 3.88075,5 2.5,5 C1.11925,5 0,3.88025 0,2.5 C0,1.11925 1.11925,0 2.5,0 C3.88075,0 5,1.11925 5,2.5 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,2.5 C12.5,3.88025 11.38075,5 10,5 C8.61975,5 7.5,3.88025 7.5,2.5 C7.5,1.11925 8.61975,0 10,0 C11.38075,0 12.5,1.11925 12.5,2.5 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,0 C18.88075,0 20,1.11925 20,2.5 C20,3.88025 18.88075,5 17.5,5 C16.11975,5 15,3.88025 15,2.5 C15,1.11925 16.11975,0 17.5,0",
    id: "Fill-5"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuWhite);
export default __webpack_public_path__ + "static/media/icMenuWhite.acc7917a2900061f3419a7ec63f6ce1f.svg";
export { ForwardRef as ReactComponent };